export function uniqueStrings(values: (string | null)[]) {
  return [...new Set(values.flatMap(value => value?.trim() || []))].toSorted((left, right) =>
    left.localeCompare(right),
  );
}
